import { Box } from "@mui/material";
import React from "react";
import { playerListStyles } from "../styles";

const BoxNumber = ({ parentIndex, childIndex }) => {
  const classes = playerListStyles();

  return childIndex % 2 == 0 ? (
    <Box className={classes.blackNumBox}>{(parentIndex + 1) * 2 - 1}</Box>
  ) : (
    <Box className={classes.blackNumBox}>{(parentIndex + 1) * 2}</Box>
  );
};

export default BoxNumber;
